import React, { useState, useEffect } from 'react';
import "./Nevbar.css";
import { FaBars, FaTimes } from "react-icons/fa";
import { NavLink } from "react-router-dom";
import { useGlobalContext } from "../Base_url/GobelContaxt";
import { BASE_URL } from "../Base_url/Base_Url";
const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [showServices, setShowServices] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const toggleServices = (e) => {
        e.preventDefault(); // prevent navigation
        setShowServices(!showServices);
    };

    const { segments, loading, error, contactData } = useGlobalContext();


    const [isVisible, setIsVisible] = useState(false);
    // Show button when scroll > 300px
    useEffect(() => {
        const toggleVisibility = () => {
            if (window.pageYOffset > 300) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener('scroll', toggleVisibility);

        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    // Scroll to top function
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    // '''''''''
    const whatsappNumber = "+91 9116839808";

    return (
        <header className="header">
            <div className="container header-container">
                {/* Logo */}
                <div className="logo">
                    <a href="/">
                        <img src="/Imges/Scroll Group 1.png" alt="Call For Cab - Tour & Travel" /></a>
                </div>

                {/* Mobile toggle button */}
                <div className="mobile-toggle" onClick={toggleMenu}>
                    {isOpen ? <FaTimes /> : <FaBars />}
                </div>

                {/* Nav Menu */}
                <div className={`nav-menu ${isOpen ? "active" : ""}`}>
                    <ul className="nav-list">
                        <li className="nav-item">
                            <NavLink to="/" className="nav-link" activeclassname="active">Home</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to="/Aboutus" className="nav-link" activeclassname="active">About Us</NavLink>
                        </li>
                        {loading ? (
                            <>

                            </>
                        ) : (
                            segments.map((seg) => (
                                <NavLink
                                    key={seg.Segment_id}
                                    to={`/${seg.slug}`}
                                    className={({ isActive }) =>
                                        `nav-item nav-link ${isActive ? "active" : ""}`
                                    }
                                >
                                    {seg.name}
                                </NavLink>
                            ))
                        )}
                        <li className="nav-item">
                            <NavLink to="/Contact" className="nav-link" activeclassname="active">Contact Us</NavLink>
                        </li>
                    </ul>
                    <a href="/Contact" className="btn">Book Now</a>
                </div>
                <button
                    className={`scroll-to-top ${isVisible ? 'show' : ''}`}
                    onClick={scrollToTop}
                    aria-label="Scroll to top"
                >
                    ⬆️
                </button>

                <a
                    href={`https://wa.me/9116839808?text=Hi/${whatsappNumber}`}
                    className="whatsapp-icon"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Chat on WhatsApp"
                >
                    <img
                        src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
                        alt="WhatsApp"
                    />
                </a>
                {/* <a
                    href={`https://wa.me/9116839808?text=Hi, I am interested in the ${ser.name} package.`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="book-btn-whats"
                >
                    <FaWhatsapp size={20} /> WhatsApp
                </a> */}


            </div>

        </header>
    );
};

export default Navbar;
